<script>
// api
import BlankPage from '../components/BlankPage'
import { queryProjectDetail, getCompanyCaseShareCard } from '~/api/project.api'
import { saveBrowsingHistory, saveCustomerOrderManager } from '~/api/common.api'
// component

import ProjectHeader from '~/components/ProjectHeader'
import ProjectProgress from '~/components/ProjectProgress'
import DecorationQuotation from '~/components/Base/DecorationQuotation'
import ProjectEventList from '~/components/ProjectEventList'
import CustomerRatings from '~/components/CustomerRatings'
import ProjectFollowGuide from '~/components/ProjectFollowGuide'
import RelatedProjects from '~/components/RelatedProjects'

import yqzConstant from '~/constant/target-type.constant'

export default {
  head() {
    const url = process.env.ONLINE_URL + this.$route.path
    const title = `${this.project.projectName}-${this.project.regionName}-${this.company.shortName}装修工地直播`
    const desc = `小区：${this.project.regionName}，面积：${this.project.decorationArea}㎡，户型：${this.project.houseType}，预算：${this.project.decorationBudget}万，风格：${this.project.decorationStyle}。${this.company.shortName}为您展示${this.project.regionName}最新最真实的装修工地详情，工地现场图片视频、施工图展示和讲解，水电、泥木、油漆等全阶段工地情况，让您的装修选择更放心！`
    const location = `province=${this.companyProvince};city=${this.companyCity}`

    return {
      title,
      meta: [
        {
          name: 'keywords',
          content: `${this.company.shortName}装修工地,${this.company.shortName}施工流程,${this.project.regionName}`
        },
        {
          name: 'description',
          content: desc
        },
        {
          name: 'og:url',
          content: url
        },
        {
          name: 'og:title',
          content: title
        },
        {
          name: 'og:description',
          content: desc
        },
        {
          name: 'location',
          content: location
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: url
        }
      ]
    }
  },
  components: {
    BlankPage,
    ProjectHeader,
    ProjectProgress,
    DecorationQuotation,
    ProjectEventList,
    CustomerRatings,
    ProjectFollowGuide,
    RelatedProjects
  },
  data() {
    return {
      dialogVisible: false,
      phoneNumber: '',
      EventItemWidth: ''
    }
  },
  async asyncData(context) {
    const {
      company,
      province: companyProvince,
      city: companyCity,
      techSupport
    } = context.store.state.company
    const projectId = context.route.params.projectId
    // 工地信息
    const project = await queryProjectDetail({
      projectId
    })
    // 工地阶段列表和当前阶段
    const stageList = project.stageList
    const canShow = !!project.projectId
    let currentStage = -1
    for (let i = 0; i < stageList.length; i++) {
      if (stageList[i].stageName === project.stage) {
        currentStage = i
      }
    }
    const qrCodeRes = await getCompanyCaseShareCard({
      targetId: project.projectId,
      targetType: yqzConstant.PROJECT,
      companyId: project.companyId
    })
    return {
      canShow,
      company,
      companyCity,
      companyProvince,
      techSupport,
      project,
      stageList,
      currentStage,
      isShow: false,
      qrCodeRes
    }
  },
  created() {
    if (this.$_thebox.clientWidth > 940) {
      this.EventItemWidth = (this.$_thebox.clientWidth - 100) * 0.6 - 70
    } else {
      this.EventItemWidth = this.$_thebox.clientWidth - 100
    }
  },
  beforeMount() {
    saveBrowsingHistory({
      targetId: this.project.projectId,
      companyId: this.project.companyId,
      targetType: yqzConstant.PROJECT
    })
  },
  methods: {
    passed,
    unpassed,
    onClickSubmit
  }
}
async function onClickSubmit(mobile) {
  const vm = this
  const res = await saveCustomerOrderManager({
    mobile,
    targetType: yqzConstant.PROJECT,
    target: vm.project.projectId,
    entryPoint: 'projectDetail_1',
    serviceName: '装修报价',
    landingPageId: 1,
    companyId: vm.project.companyId
  })
  if (res.judge) {
    this.$notify({
      message: res.msg,
      type: 'success',
      duration: 3000
    })
  } else {
    this.$notify({
      message: res.msg,
      type: 'warning',
      duration: 3000
    })
  }
  vm.dialogVisible = false
}

function passed() {
  this.isShow = true
}
function unpassed() {
  this.isShow = false
}
</script>
<template>
  <div class="project_detail_container">
    <div class="app_header">
      <nuxt-link :to="`/company/${company.companyId}`" :target="$_newtab">
        <div class="app_header_logo">
          <img :src="project.companyLogoOssUrl || defaultCompanyLogo" />
        </div>
      </nuxt-link>
      <nuxt-link :to="`/company/${company.companyId}`" :target="$_newtab">
        <h2 class="app_header_project_short_name">{{ project.shortName }}</h2>
      </nuxt-link>
    </div>

    <BlankPage v-if="!canShow" />
    <div v-else>
      <div class="project_page">
        <div class="project_header">
          <ProjectHeader :project="project" />
        </div>
        <div class="project_content">
          <div class="project_progress project_content_left">
            <h3>装修阶段</h3>
            <div class="line_placeholder hide_on_mobile" />
            <div class="progress_container">
              <ProjectProgress
                :stage-list="stageList"
                :current-stage="currentStage"
              />
            </div>
          </div>
          <div v-passed="{ passed, unpassed }" class="quotation_and_qr">
            <div class="decoration_quotation_container">
              <div v-if="isShow" class="quotation_title">
                {{ company.shortName }}
              </div>
              <DecorationQuotation @click-quotation="dialogVisible = true">
                <strong>免费报价</strong>
              </DecorationQuotation>
            </div>
            <!-- <div v-if="isShow" style="height:30px;" /> -->
            <div class="project_follow_guide hide_on_mobile">
              <div class="follow_guide_container">
                <ProjectFollowGuide
                  v-if="qrCodeRes"
                  :qr-content="qrCodeRes.qrCode"
                  :company-logo="project.companyLogoOssUrl"
                />
              </div>
            </div>
          </div>
          <div class="project_event_list project_content_left">
            <h3>装修动态</h3>
            <div class="line_placeholder line_after_1px hide_on_mobile" />
            <ProjectEventList :width="EventItemWidth" />
          </div>
          <div v-show="project.evaluateNum > 0" class="customer_ratings">
            <h3>业主评价</h3>
            <div class="line_placeholder line_after_1px hide_on_mobile" />
            <CustomerRatings
              :sum="project.evaluateNum"
              :width="EventItemWidth"
            />
          </div>
          <div class="related_projects">
            <h3 class="pc_owner_h1">更多相关工地</h3>
            <div>
              <RelatedProjects />
            </div>
          </div>

          <div class="project_footer_mobile hide_on_pc">
            <a :href="techSupport.link">{{ techSupport.description }}</a>
          </div>
          <!-- 获取报价弹窗 -->
          <QuotationDialog
            :visible.sync="dialogVisible"
            :title="company.shortName + '为你免费报价'"
            @click-submit="onClickSubmit"
          />
        </div>
      </div>
      <div class="decoration_quotation_mobile hide_on_pc">
        <DecorationQuotation @click-quotation="dialogVisible = true">
          <strong>免费报价</strong>
        </DecorationQuotation>
      </div>
      <div class="project_footer hide_on_mobile">
        <a :href="techSupport.link">{{ techSupport.description }}</a>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.project_detail_container {
  .project_footer {
    width: 100%;
    height: 52px;
    background: rgba(247, 247, 247, 1);
    text-align: center;
    a {
      font-size: 12px;
      font-weight: 600;
      color: rgba(155, 155, 155, 1);
      line-height: 52px;
    }

    position: relative;
    bottom: 0;
  }

  h1 {
    font-size: 22px;
    font-weight: 600;
    color: rgba(68, 68, 68, 1);
    line-height: 22px;
  }

  .app_header {
    .app_header_logo {
      width: 36px;
      height: 36px;
      > img {
        object-fit: cover;
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
    .app_header_project_short_name {
      font-size: 20px;
      font-weight: 500;
      color: rgba(42, 42, 42, 1);
      line-height: 20px;
      padding-left: 10px;
    }
  }

  .project_page {
    .project_header {
      height: 380px;
    }
    .project_content {
      margin-top: 25px;
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      > div {
        flex-basis: 40%;
      }
      .project_content_left {
        flex-basis: 60%;
      }
      .project_progress {
        padding-top: 33px;
        height: 230px;
        h1 {
          font-size: 22px;
        }
        .progress_container {
          margin: 60px 33px 0 33px;
        }
      }
      .quotation_and_qr {
        position: sticky;
        top: 0;
        height: 120px;
        z-index: 2000;

        .decoration_quotation_container {
          border: 1px solid rgba(239, 241, 242, 1);
          background: white;
          padding: 30px 25px;
          .quotation_title {
            margin-bottom: 30px;
            text-align: center;
            font-size: 20px;
            color: rgba(68, 68, 68, 1);
            line-height: 20px;
          }
        }
        padding-left: 50px;
      }
      .project_event_list {
        padding-top: 45px;
        h1 {
          font-size: 22px;
        }
      }
      .customer_ratings {
        padding-top: 60px;
        flex-basis: 60%;
        h1 {
          font-size: 22px;
        }
      }
      .project_follow_guide {
        background: white;
        z-index: 2000;
        // padding-left: 50px;
        padding-top: 30px;
        .follow_guide_container {
          height: 100%;
          border-radius: 2px;
          border: 1px solid rgba(239, 241, 242, 1);
        }
      }
      //模块标题下的横线,在mobile下不显示
      .line_placeholder {
        height: 25px;
      }
      .related_projects {
        z-index: 1999;
        flex-basis: 100%;
        margin-bottom: 100px;
        margin-top: 80px;
        position: sticky;
        background-color: white;
        top: 0;
        > div {
          margin-top: 25px;
        }
      }
    }
  }
  @media screen and (min-width: 940px) {
    .project_page {
      margin: 0 50px;
    }
  }

  //仅在mobile下
  @media screen and (max-width: 940px) {
    .project_page {
      max-width: 940px;
      margin: 0 auto;
      .project_header {
        height: 570px;
        border-bottom: 10px solid rgba(239, 241, 242, 1);
      }
      .project_content {
        > div {
          flex-basis: 100%;
        }
        .project_content_left {
          flex-basis: 100%;
          border-bottom: 10px solid rgba(239, 241, 242, 1);
        }
        .project_progress {
          padding-left: 15px;
          padding-top: 0;
          height: 123px;
          .progress_container {
            font-size: 12px;
            margin: 25px 23px 25px 0px;
          }
        }
        .quotation_and_qr {
          visibility: hidden;
          position: absolute;
        }
        .project_event_list {
          padding: 25px 0 25px 15px;
        }
        .customer_ratings {
          flex-basis: 100%;
          margin-top: 0;
          padding: 25px 15px 25px 15px;
          border-bottom: 10px solid #eff1f2;
          h1 {
            margin-bottom: 0;
          }
        }

        .related_projects {
          margin-top: 25px;
          margin-bottom: 50px;
          padding-left: 15px;
          width: 100%;
          > div {
            margin-top: 10px;
          }
        }
      }
    }

    .project_footer_mobile {
      display: block;
      height: 124px;
      a {
        line-height: 52px;
        font-size: 12px;
        font-weight: 600;
        color: rgba(155, 155, 155, 1);
      }

      background: rgba(242, 244, 245, 1);
      text-align: center;
    }

    .decoration_quotation_mobile {
      position: fixed;
      bottom: 0;
      display: block;
      width: 100%;
      z-index: 100;
      padding: 14px 20px 19px 20px;
    }
  }
}
</style>
